import React from "react";
import { finalCtaCards } from "../../../../Utils/staticData";
import "./index.scss";

const CTA = () => {
  return (
    <div className="final-cta-wrapper">
      <div className="final-cta-container">
        {finalCtaCards.map((card) => (
          <div
            className={`final-cta-card final-cta-card--${card.variant}`}
            key={card.heading}
          >
            <div className="final-cta-icon">{card.icon}</div>
            <h3 className="final-cta-heading">{card.heading}</h3>
            <a
              href={card.href}
              target="_blank"
              rel="noreferrer"
              className={`final-cta-button final-cta-button--${card.variant}`}
            >
              {card.buttonLabel}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CTA;
